import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {medicalSuppliesService} from "api";
import {
  Row,
  Spin,
  Form,
  Button,
  Space,
  Typography,
  Divider,
  Popconfirm,
} from "antd";
import {InputFields} from "components/common";
import {columns as columnsInit, inputFields as inputFieldsInit} from "./config";
import Icons from "assets/icons";
import TableInputAdd from "./TableInputAdd/TableInputAdd";

import {
  // FORMAT_TIME,
  LOAI_FORM,
  // LOAI_PHIEU_KHO,
  LOAI_PHIEU_VTYT,
  TT_PHIEU_VTYT,
  tabKeys,
} from "types/enums";
import moment from "moment";
import {
  convertIosStringToDateDayjs,
  formatDateToString,
  isValuable,
  jsonParse,
  randomId,
  toArray,
  toNumber,
} from "helper/common";
import {setActiveKey} from "redux/reducer/common";
import {setKhoNhapId, setKhoXuatId} from "redux/reducer/tableAdd";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalDeny from "./ModalDeny/ModalDeny";
import {
  searchMedicalSuppliesAPI,
  setDetailRecord,
  setIsReloadApi,
  setStatusPhieu,
  setSelectedRecord,
  getSupplierAPI,
  getDonViApAPI,
  setTypeForm,
  getListVTYTAPI,
} from "redux/reducer/medicalSupplies";
import Notification from "components/common/notification/notification";
import dayjs from "dayjs";
import {convertListContainDate} from "helper/format-date";
import ReceiptModal from "./ReceiptModal/ReceiptModal";
import BoVTModal from "./BoVTModal/BoVTModal";
import {getListQuyCach, getListUnitAPI} from "helper/call-api-list";
const Detail = () => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<any>();
  const khoVTYTQuanLy = JSON.parse(localStorage.getItem("khoVTYTQuanLyLocal"));

  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );
  const selectedMedicalSupplies = medicalSuppliesStore.selectedMedicalSupplies;
  const detailRecord = medicalSuppliesStore.detailRecord;
  const selectedRecord = medicalSuppliesStore.selectedRecord;
  const [textStatusPhieu, setTextStatusPhieu] = useState("");
  const [textTypePhieu, setTextTypePhieu] = useState<any>();
  const statusPhieu = medicalSuppliesStore.statusPhieu;
  const typeForm = medicalSuppliesStore.typeForm;
  const typePhieu = medicalSuppliesStore.typePhieu;
  const receiptRef = useRef<any>();
  const boVTRef = useRef<any>();
  const childRef = useRef<any>();
  // const listStore = useAppSelector((state) => state.pharmacyStore.listStore);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputFields, setInputFields] = useState(inputFieldsInit);
  const [formReceiptDto] = Form.useForm();
  const [formTable] = Form.useForm();
  const [columns, setColumns] = useState(columnsInit);
  const [data, setData] = useState<any[]>([]);
  const [dataDeny, setDataDeny] = useState<any>();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const khoXuatId = Form.useWatch("khoXuatId", formReceiptDto);
  useEffect(() => {
    dispatch(getSupplierAPI());
    dispatch(getDonViApAPI({}));
    // dispatch(searchMedicalSuppliesAPI({}));
  }, []);
  useEffect(() => {
    setOnChangeStore();
  }, [typePhieu, medicalSuppliesStore.suppliesStoreList]);
  useEffect(() => {
    const setRuleOfColumn = () => {
      columns.find(e => e.dataIndex == "ngayHetHan").rules =
        typePhieu == LOAI_PHIEU_VTYT.NHAP
          ? [{required: true, message: "Chưa nhập ngày hết hạn"}]
          : [];
      // console.log(columns);
      setColumns([...columns]);
    };
    setRuleOfColumn();
  }, [typePhieu]);

  useEffect(() => {
    if (jsonParse(localStorage.getItem("donVi"))?.length == 0) {
      getListUnitAPI();
    }
    if (toArray(jsonParse(localStorage.getItem("quyCach")))?.length == 0) {
      getListQuyCach();
    }
  }, []);
  useEffect(() => {
    setDataTable([]);

    if (typeForm == LOAI_FORM.DA_TAO) {
      console.log(selectedRecord);
      getDetailReceiptAPI(selectedRecord?.id);
    }
    dispatch(setStatusPhieu(selectedRecord?.tinhTrang));
  }, [selectedRecord, typeForm]);
  useEffect(() => {
    const disableFields = () => {
      const listFields = [
        "tieuDe",
        "ngayHoaDon",
        "soHoaDon",
        "khoNhapId",
        "nhaCungCapId",
        "khoXuatId",
        "nguonVTYTId",
        "nguoiLap",
        "ngayDuTru",
        "nguoiGiao",
        "nguoiNhan",
        "ngayHoanThanh",
        "tongGiaTri",
        // "description",
      ];
      listFields.forEach(field => {
        inputFields.find(e => e.name == field).disable =
          detailRecord?.receiptDto?.tinhTrang == TT_PHIEU_VTYT.HOAN_THANH ||
          detailRecord?.receiptDto?.isFromPhieuXuat;
      });
    };
    disableFields();
  }, [detailRecord]);
  useEffect(() => {
    if (typeForm == LOAI_FORM.TAO_MOI_PT) {
      dispatch(setStatusPhieu(TT_PHIEU_VTYT.NHAP));
      formReceiptDto.setFieldValue("tinhTrang", TT_PHIEU_VTYT.NHAP);
    }
    if (typeForm == LOAI_FORM.TAO_MOI) {
      const khoUserId = khoVTYTQuanLy?.value;
      formReceiptDto.resetFields();
      formReceiptDto.setFieldValue(
        "nguoiLap",
        localStorage.getItem("fullName")
      );
      dispatch(setStatusPhieu(TT_PHIEU_VTYT.NHAP));
      formReceiptDto.setFieldValue("tinhTrang", TT_PHIEU_VTYT.NHAP);
      if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
        if (khoUserId === 0 || khoUserId) {
          formReceiptDto.setFieldValue("khoXuatId", khoUserId);
          dispatch(setKhoXuatId(khoUserId));
        }
        if (selectedMedicalSupplies.length == 0) {
          setDataTable([]);
        } else {
          formReceiptDto.setFieldValue(
            "khoXuatId",
            selectedMedicalSupplies[0]?.storeId
          );
        }
      }

      if (
        typePhieu == LOAI_PHIEU_VTYT.NHAP ||
        typePhieu == LOAI_PHIEU_VTYT.DU_TRU
      ) {
        setDataTable([]);
        if (khoUserId === 0 || khoUserId) {
          formReceiptDto.setFieldValue("khoNhapId", khoUserId);
        }
      }
      if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
        formReceiptDto.setFieldValue("ngayHoaDon", dayjs());
      }
    }
  }, [typeForm, typePhieu, khoVTYTQuanLy?.value]);
  const setDataTable = (value: any[] | []) => {
    setData(value);

    formTable.setFieldValue(
      "listVTYTReceiptDetailDto",
      convertListContainDate(value, [
        "ngayHetHan",
        "ngaySanXuat",
        "ngayThongBaoHH",
      ])
    );
  };
  useEffect(() => {
    if (selectedMedicalSupplies.length > 0) {
      setDataTable(
        selectedMedicalSupplies.map(supplie => ({
          ...supplie,
          soLuong: supplie.xuatDuKien || null,
          giaTriHang:
            typePhieu == LOAI_PHIEU_VTYT.NHAP
              ? Number(supplie.donGiaNhap || 0) *
                Number(supplie.xuatDuKien || 0)
              : Number(supplie.donGiaXuat || 0) *
                Number(supplie.xuatDuKien || 0),
        }))
      );

      dispatch(setKhoXuatId(selectedMedicalSupplies[0]?.storeId));
      formReceiptDto.setFieldValue(
        "khoXuatId",
        selectedMedicalSupplies[0]?.storeId
      );
      formReceiptDto.setFieldValue(
        "nguoiLap",
        localStorage.getItem("fullName")
      );
    }
  }, [selectedMedicalSupplies]);
  useEffect(() => {
    if (activeTab != tabKeys.MEDICAL_SUPPLIES_STORE.DETAIL) {
      reset();
    }
  }, [activeTab]);
  useEffect(() => {
    const getListVTYT = () => {
      if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
        if (isValuable(khoXuatId)) {
          dispatch(
            getListVTYTAPI({
              // tenTheoThuongMai: getFieldValue("tenTheoThuongMai"),
              storeId: khoXuatId,
            })
          );
        } else {
          // Notification("warning", "Chưa chọn kho xuất");
        }
      } else {
        dispatch(
          getListVTYTAPI({
            // tenTheoThuongMai: getFieldValue("tenTheoThuongMai"),
          })
        );
      }
    };
    getListVTYT();
  }, [khoXuatId, typePhieu]);
  useEffect(() => {
    if (detailRecord && typeForm == LOAI_FORM.TAO_MOI_PT) {
      setFormFieldsValue(detailRecord?.receiptDto);
      setDataTable([...detailRecord.listVTYTReceiptDetailDto]);
    }
    if (detailRecord && typeForm == LOAI_FORM.DA_TAO) {
      setFormFieldsValue(detailRecord?.receiptDto);
      if (
        typePhieu == LOAI_PHIEU_VTYT.XUAT ||
        typePhieu == LOAI_PHIEU_VTYT.DU_TRU
      ) {
        dispatch(setKhoXuatId(detailRecord?.receiptDto?.khoXuatId));
      }
    }
    // else {
    //   form.resetFields();
    // }
    if (detailRecord) {
      dispatch(setKhoNhapId(detailRecord?.receiptDto?.khoNhapId));
      dispatch(setKhoXuatId(detailRecord?.receiptDto?.khoXuatId));
      setDataTable([
        ...detailRecord.listVTYTReceiptDetailDto?.map(e => ({
          ...e,
          key: randomId(),
        })),
      ]);
      // setData([]);
    } else {
      formReceiptDto.setFieldValue(
        "nguoiLap",
        localStorage.getItem("fullName")
      );
    }
  }, [detailRecord]);

  useEffect(() => {
    if (statusPhieu == TT_PHIEU_VTYT.CHO_DUYET) {
      setTextStatusPhieu("Chờ duyệt");
    }
    if (statusPhieu == TT_PHIEU_VTYT.CANH_BAO) {
      setTextStatusPhieu("Cảnh báo");
    }
    if (statusPhieu == TT_PHIEU_VTYT.NHAP) {
      setTextStatusPhieu("Nháp");
    }
    if (statusPhieu == TT_PHIEU_VTYT.HOAN_THANH) {
      setTextStatusPhieu("Hoàn thành");
    }
    if (statusPhieu == TT_PHIEU_VTYT.TU_CHOI) {
      setTextStatusPhieu("Từ chối");
    }
    if (statusPhieu == TT_PHIEU_VTYT.HUY) {
      setTextStatusPhieu("Hủy");
    }
    formReceiptDto.setFieldValue("tinhTrang", statusPhieu);
  }, [statusPhieu]);
  useEffect(() => {
    const listKey = [
      "tieuDe",
      "ngayHoaDon",
      "soHoaDon",
      "khoNhapId",
      "nhaCungCapId",
      "khoXuatId",
      "nguonVTYTId",
      "nguoiLap",
      "ngayDuTru",
      "nguoiGiao",
      "nguoiNhan",
      "ngayHoanThanh",
      "tongGiaTri",
      "description",
    ];
    const res: any = listKey.forEach(key => {
      inputFieldsInit.map(e => e?.name == key);
    });
    // res.lable = statusPhieu == TT_PHIEU_VTYT.HOAN_THANH;
    setInputFields([...inputFieldsInit]);
  }, [statusPhieu]);
  useEffect(() => {
    const setText = () => {
      if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
        setTextTypePhieu("nhập");
        // const newColumns = columns;
      }
      if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
        setTextTypePhieu("xuất");
      }
      if (typePhieu == LOAI_PHIEU_VTYT.DU_TRU) {
        setTextTypePhieu("dự trù");
      }
    };
    const setFieldShow = () => {
      inputFieldsInit.find(e => e.name == "nhaCungCapId").hide =
        typePhieu == LOAI_PHIEU_VTYT.DU_TRU;
      inputFieldsInit.find(e => e.name == "ngayHoaDon").hide =
        typePhieu != LOAI_PHIEU_VTYT.NHAP;
      inputFieldsInit.find(e => e.name == "soHoaDon").hide =
        typePhieu == LOAI_PHIEU_VTYT.DU_TRU;
      inputFieldsInit.find(e => e.name == "soHoaDon").rules =
        typePhieu == LOAI_PHIEU_VTYT.NHAP
          ? [{required: true, message: "Chưa nhập số hóa đơn"}]
          : [];

      setInputFields([...inputFieldsInit]);
    };
    const setDetailFieldName = () => {
      columns.find(column => column.key === "soLuong").title =
        getSoLuongFieldName();

      setColumns(columns);
    };
    const setColumnShow = () => {
      columns.find(column => column.key === "ngayThongBaoHH").show =
        typePhieu == LOAI_PHIEU_VTYT.NHAP;
      columns.find(column => column.key === "discount").show =
        typePhieu == LOAI_PHIEU_VTYT.XUAT;

      setColumns(columns);
    };
    setColumnShow();
    setDetailFieldName();
    setText();
    setFieldShow();
  }, [typePhieu]);
  useEffect(() => {
    const setDisabledColumns = () => {
      columns.find(column => column.key === "ngaySanXuat").disabled =
        detailRecord?.receiptDto?.loaiPhieu != LOAI_PHIEU_VTYT.NHAP ||
        detailRecord?.receiptDto?.isFromPhieuXuat;
      columns.find(column => column.key === "ngayHetHan").disabled =
        detailRecord?.receiptDto?.loaiPhieu != LOAI_PHIEU_VTYT.NHAP ||
        detailRecord?.receiptDto?.isFromPhieuXuat;

      columns.find(column => column.key === "giaTriBHChiTra").disabled =
        detailRecord?.receiptDto?.loaiPhieu != LOAI_PHIEU_VTYT.NHAP ||
        detailRecord?.receiptDto?.isFromPhieuXuat;
      columns.find(column => column.key === "soLo").disabled =
        detailRecord?.receiptDto?.loaiPhieu === LOAI_PHIEU_VTYT.NHAP ||
        detailRecord?.receiptDto?.isFromPhieuXuat;
      setColumns(columns);
    };
    setDisabledColumns();
  }, [detailRecord]);
  useEffect(() => {
    setOptionsSearchFields(medicalSuppliesStore.suppliesStoreList, "khoNhapId");
    setOptionsSearchFields(medicalSuppliesStore.suppliesStoreList, "khoXuatId");
  }, [medicalSuppliesStore.suppliesStoreList]);
  useEffect(() => {
    medicalSuppliesStore.nguonVTYTList &&
      setOptionsSearchFields(medicalSuppliesStore.nguonVTYTList, "nguonVTYTId");
  }, [medicalSuppliesStore.nguonVTYTList]);
  useEffect(() => {
    setOptionsSearchFields(medicalSuppliesStore.supplierList, "nhaCungCapId");
  }, [medicalSuppliesStore.supplierList]);

  const setOptionsSearchFields = (list, name) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.id,
          label: item.name,
          key: randomId(),
        })
      );
    }
  };

  const getSoLuongFieldName = () => {
    let soLuongFieldName = "";
    if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
      soLuongFieldName = "Số xuất";
    } else if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
      soLuongFieldName = "Số nhập";
    } else {
      soLuongFieldName = "Số dự trù";
    }
    return soLuongFieldName;
  };

  const setTongTien = tongGiaTriDon => {
    formReceiptDto.setFieldValue("tongGiaTri", toNumber(tongGiaTriDon));
  };
  const setFormFieldsValue = data => {
    const formValue = {
      ...data,
      tongGiaTri: data?.tongGiaTri || 0,
      nguoiLap: data?.nguoiLap || localStorage.getItem("fullName"),
      ngayDuTru: data?.ngayDuTru ? moment(data?.ngayDuTru) : undefined,
      ngayHoanThanh: data?.ngayHoanThanh
        ? moment(data?.ngayHoanThanh)
        : undefined,
      ngayHoaDon: convertIosStringToDateDayjs(data?.ngayHoaDon),
    };
    formReceiptDto.setFieldsValue(formValue);
  };
  // const setOptionsStore = () => {
  //   const options = listStore.map((e) => ({ value: e.id, label: e.name }));
  //   inputFields.find((e) => e.name == "khoNhapId").options = options;
  //   inputFields.find((e) => e.name == "khoXuatId").options = options;
  //   setInputFields([...inputFields]);
  // };
  const setOnChangeStore = () => {
    inputFields.find(e => e.name == "khoNhapId").onChange = e => {
      dispatch(setKhoNhapId(e));
      const required =
        medicalSuppliesStore.suppliesStoreList.find(store => store.id == e)
          ?.name == "Các Kho nhà cung cấp" && typePhieu == LOAI_PHIEU_VTYT.XUAT;
      const requiredXuat =
        medicalSuppliesStore.suppliesStoreList.find(store => store.id == e)
          ?.name == "Các Kho nhà cung cấp" && typePhieu == LOAI_PHIEU_VTYT.NHAP;

      inputFields.find(e => e?.name == "soHoaDon").rules = required
        ? [{required: true, message: "Chưa nhập số hóa đơn"}]
        : [];
      inputFields.find(e => e?.name == "nhaCungCapId").rules = required
        ? [{required: true, message: "Chưa chọn nhà cung cấp"}]
        : [];
      if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
        inputFields.find(e => e?.name == "nhaCungCapId").rules = requiredXuat
          ? [{required: true, message: "Chưa chọn nhà cung cấp"}]
          : [];
      }

      setInputFields([...inputFields]);
    };
    inputFields.find(e => e.name == "khoXuatId").onChange = e => {
      dispatch(setKhoXuatId(e));
    };
    setInputFields([...inputFields]);
  };
  const getValueReceipt = async (tinhTrang, loaiPhieu) => {
    await formReceiptDto.validateFields();
    const formValue = formReceiptDto.getFieldsValue();
    const formTableValue = formTable.getFieldValue("listVTYTReceiptDetailDto");
    const listVTYTReceiptDetailDto = formTableValue.map(e => {
      if (selectedMedicalSupplies?.length) {
        const medicalSupplie = selectedMedicalSupplies.find(
          supplie => supplie.soLo === e.soLo
        );

        return medicalSupplie
          ? {
              ...medicalSupplie,
              ...e,
              soLuong: e.soLuong,
              ngayHetHan: formatDateToString(e.ngayHetHan, null),
              ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
              createDate: formatDateToString(e?.createDate, null),
              modifyDate: formatDateToString(e?.modifyDate, null),
              donViTinhId: Number(e?.donViTinhId),
            }
          : {
              ...e,
              soLuong: e.soLuong,
              ngayHetHan: formatDateToString(e.ngayHetHan, null),
              ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
              createDate: formatDateToString(e?.createDate, null),
              modifyDate: formatDateToString(e?.modifyDate, null),
              donViTinhId: Number(e?.donViTinhId),
            };
      }
      if (detailRecord?.length) {
        const medicalSupplieRecord =
          detailRecord?.listVTYTReceiptDetailDto.find(
            supplie => supplie.soLo === e.soLo
          );
        return medicalSupplieRecord
          ? {
              ...medicalSupplieRecord,
              ...e,
              soLuong: e.soLuong,
              ngayHetHan: formatDateToString(e.ngayHetHan, null),
              ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
              createDate: formatDateToString(e?.createDate, null),
              modifyDate: formatDateToString(e?.modifyDate, null),
              donViTinhId: Number(e?.donViTinhId),
            }
          : {
              ...e,
              soLuong: e.soLuong,
              ngayHetHan: formatDateToString(e.ngayHetHan, null),
              ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
              createDate: formatDateToString(e?.createDate, null),
              modifyDate: formatDateToString(e?.modifyDate, null),
              donViTinhId: Number(e?.donViTinhId),
            };
      }
      if (!selectedMedicalSupplies?.length && !detailRecord?.length) {
        const medicalSupplieData =
          medicalSuppliesStore.medicalSuppliesList.find(
            medicalSupplie => medicalSupplie.soLo === e.soLo
          );
        return {
          ...medicalSupplieData,
          ...e,
          soLuong: e.soLuong,
          ngayHetHan: formatDateToString(e.ngayHetHan, null),
          ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
          createDate: formatDateToString(e?.createDate, null),
          modifyDate: formatDateToString(e?.modifyDate, null),
          donViTinhId: Number(e?.donViTinhId),
        };
      }
    });

    const receiptDto = {
      ...formValue,
      tinhTrang: tinhTrang,
      loaiPhieu: loaiPhieu,
      khoXuatId:
        loaiPhieu == LOAI_PHIEU_VTYT.NHAP
          ? formValue?.khoXuatId ?? 17
          : formValue?.khoXuatId,
    };

    if (listVTYTReceiptDetailDto.length == 0) {
      Notification("error", "Không có vật tư trong bảng");
      return false;
    } else {
      return {
        receiptDto: receiptDto,
        listVTYTReceiptDetailDto: listVTYTReceiptDetailDto.map(e => {
          if (e?.soLo?.toString()?.trim() == "") {
            // console.log(e?.soLo);
            return {...e, soLo: null};
          } else {
            return {...e, soLo: e?.soLo?.toString()?.trim()};
          }
        }),
      };
    }
  };
  const reset = () => {
    // dispatch(setSelectedMedicinesExport([]));
    dispatch(setDetailRecord(null));
    dispatch(setSelectedRecord(null));
    dispatch(setKhoXuatId(null));
    dispatch(setKhoNhapId(null));
    dispatch(setTypeForm(null));
  };
  const getDetailReceiptAPI = async id => {
    try {
      setLoading(true);
      const res = await medicalSuppliesService.getDetailReceipt(id);
      setLoading(false);
      dispatch(setDetailRecord(res));
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy thông tin phiếu");
    }
  };
  const titleConfirm = () => {
    if (
      typeForm == LOAI_FORM.TAO_MOI ||
      typeForm == LOAI_FORM.TAO_MOI_PT ||
      (typeForm == LOAI_FORM.DA_TAO && statusPhieu == TT_PHIEU_VTYT.NHAP)
    ) {
      return "Đồng ý hủy phiếu";
    }
    if (
      typeForm == LOAI_FORM.DA_TAO &&
      statusPhieu == TT_PHIEU_VTYT.CHO_DUYET
    ) {
      return "Từ chối duyệt phiếu";
    } else {
      return "";
    }
  };

  const checkNgayHetHan = async () => {
    const valid = !(
      formTable
        .getFieldValue("listVTYTReceiptDetailDto")
        .findIndex(e => !e?.ngayHetHan) >= 0
    );
    if (!valid) {
      Notification("error", "Chưa nhập ngày hết hạn");
    }
    return valid;
  };
  const validTable = async () => {
    try {
      await formTable.validateFields();
      return true;
    } catch (error) {
      return false;
    }
  };
  const save = async () => {
    const detailData: any = await getValueReceipt(
      TT_PHIEU_VTYT.NHAP,
      typePhieu
    );
    const _validTable = await validTable();
    if (detailData && _validTable) {
      if (typeForm == LOAI_FORM.TAO_MOI || typeForm == LOAI_FORM.TAO_MOI_PT) {
        try {
          setLoadingBtn(true);
          const res = await medicalSuppliesService.postImportForm(detailData);
          Notification("success", `Tạo phiếu ${textTypePhieu} thành công`);
          setLoadingBtn(false);
          dispatch(setTypeForm(LOAI_FORM.DA_TAO));
          dispatch(setSelectedRecord(res?.receiptDto));
          // reset();
          // navigateToTabList();
        } catch (error) {
          setLoadingBtn(false);
          Notification(
            "error",
            error?.response?.data ?? `Đã có lỗi khi tạo phiếu ${textTypePhieu}`
          );
        }
      }

      if (typeForm == LOAI_FORM.DA_TAO) {
        var data = await getValueReceipt(statusPhieu, typePhieu);
        if (data) {
          try {
            setLoadingBtn(true);
            const res = await medicalSuppliesService.updateImportForm(data);
            Notification("success", `Đã lưu thông tin phiếu ${textTypePhieu}`);
            dispatch(setTypeForm(LOAI_FORM.DA_TAO));
            dispatch(setSelectedRecord(res?.receiptDto));
            setLoadingBtn(false);
            // reset();
            // navigateToTabList();
          } catch (error) {
            setLoadingBtn(false);
            Notification(
              "error",
              error?.response?.data ??
                `Đã có lỗi khi lưu thông tin phiếu ${textTypePhieu}`
            );
          }
        }
      }
    }
  };
  const cancel = async () => {
    if (statusPhieu == TT_PHIEU_VTYT.NHAP) {
      const receiptDto = {
        ...formReceiptDto.getFieldsValue(),
        tinhTrang:
          typePhieu == LOAI_PHIEU_VTYT.DU_TRU
            ? TT_PHIEU_VTYT.TU_CHOI
            : TT_PHIEU_VTYT.HUY,
        loaiPhieu: typePhieu,
      };
      const data = {receiptDto: receiptDto, listVTYTReceiptDetailDto: []};
      try {
        setLoadingBtn(true);
        await medicalSuppliesService.updateImportForm(data);
        reset();
        setLoadingBtn(false);
        navigateToTabList();
      } catch (error) {
        setLoadingBtn(false);
        Notification(
          "error",
          error?.response?.data ??
            `Đã có lỗi khi hủy thông tin phiếu ${textTypePhieu}`
        );
      }
    }
    if (statusPhieu == TT_PHIEU_VTYT.CHO_DUYET) {
      const receiptDto = {
        ...formReceiptDto.getFieldsValue(),
        tinhTrang: TT_PHIEU_VTYT.TU_CHOI,
        loaiPhieu: typePhieu,
      };
      const data = {receiptDto: receiptDto, listVTYTReceiptDetailDto: []};
      modalRef.current?.openModal();
      setDataDeny(data);
    }
  };

  const handleDeny = async description => {
    let data = dataDeny;
    data = {
      ...data,
      receiptDto: {...data.receiptDto, description: description},
    };
    try {
      setLoadingBtn(true);
      await medicalSuppliesService.updateImportForm(data);
      modalRef.current?.closeModal();
      setLoadingBtn(false);
      reset();
      navigateToTabList();
    } catch (error) {
      setLoadingBtn(false);
      Notification(
        "error",
        `Đã có lỗi khi từ chối thông tin phiếu ${textTypePhieu}`
      );
    }
  };
  const send = async () => {
    const detailData: any = await getValueReceipt(
      TT_PHIEU_VTYT.CHO_DUYET,
      typePhieu
    );
    const _validTable = await validTable();
    if (detailData && _validTable) {
      if (statusPhieu == TT_PHIEU_VTYT.NHAP) {
        // var data = await getValueReceipt(TT_PHIEU_VTYT.CHO_DUYET, typePhieu);
        try {
          let res;
          setLoadingBtn(true);
          if (typeForm == LOAI_FORM.DA_TAO) {
            res = await medicalSuppliesService.updateImportForm(detailData);
          }
          if (
            typeForm == LOAI_FORM.TAO_MOI ||
            typeForm == LOAI_FORM.TAO_MOI_PT
          ) {
            res = await medicalSuppliesService.postImportForm(detailData);
          }
          setLoadingBtn(false);
          dispatch(setTypeForm(LOAI_FORM.DA_TAO));
          dispatch(setSelectedRecord(res?.receiptDto));

          Notification("success", `Đã gửi thông tin phiếu ${textTypePhieu}`);
          // navigateToTabList();
          // reset();
        } catch (error) {
          Notification(
            "error",
            error?.response?.data ??
              `Đã có lỗi khi gửi thông tin phiếu ${textTypePhieu}`
          );
          setLoadingBtn(false);
        }
      } else {
        setLoadingBtn(false);
        Notification(
          "warning",
          `Không thể gửi duyệt phiếu ở trạng thái ${textStatusPhieu}`
        );
      }
    }
  };
  const navigateToTabList = async () => {
    await dispatch(setIsReloadApi(true));
    if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
      dispatch(setActiveKey(tabKeys.MEDICAL_SUPPLIES_STORE.EXPORT));
    }
    if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
      dispatch(setActiveKey(tabKeys.MEDICAL_SUPPLIES_STORE.IMPORT));
    }
    if (typePhieu == LOAI_PHIEU_VTYT.DU_TRU) {
      dispatch(setActiveKey(tabKeys.MEDICAL_SUPPLIES_STORE.RESERVE));
    }
  };
  const complete = async () => {
    const detailData: any = await getValueReceipt(
      TT_PHIEU_VTYT.HOAN_THANH,
      typePhieu
    );
    const _validTable = await validTable();
    const _validNgayHetHan = checkNgayHetHan();

    if (
      statusPhieu != TT_PHIEU_VTYT.HUY &&
      statusPhieu != TT_PHIEU_VTYT.TU_CHOI
    ) {
      if (detailData && _validTable && _validNgayHetHan) {
        try {
          setLoadingBtn(true);
          const res = await medicalSuppliesService.updateImportForm(detailData);
          Notification(
            "success",
            `Đã cập nhật phiếu ${textTypePhieu} thành trạng thái hoàn thành`
          );
          dispatch(setTypeForm(LOAI_FORM.DA_TAO));
          dispatch(setSelectedRecord(res?.receiptDto));
          setLoadingBtn(false);
          // reset();
          // navigateToTabList();
        } catch (error) {
          Notification(
            "error",
            error?.response?.data ??
              `Đã có lỗi khi hoàn thành phiếu ${textTypePhieu}`
          );
          setLoadingBtn(false);
        }
      }
    } else {
      setLoadingBtn(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="detail-patient-analysis">
        <div className="container">
          <Typography.Text strong>
            Thông tin phiếu {textTypePhieu}
          </Typography.Text>
          <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
          <div className="container-main">
            <Form form={formReceiptDto}>
              <Row gutter={[16, 8]}>
                {" "}
                {inputFields && <InputFields data={inputFields}></InputFields>}
              </Row>
              <Row justify={"end"} style={{marginTop: 8}}>
                <Space size={"small"}>
                  <Button
                    icon={<Icons.file />}
                    className="btn-sub"
                    onClick={() => {
                      receiptRef.current?.openModal();
                    }}
                  >
                    In phiếu
                  </Button>
                  <Popconfirm
                    title={titleConfirm}
                    onConfirm={cancel}
                    okText="Đồng ý"
                    cancelText="Hủy"
                  >
                    <Button
                      type="primary"
                      danger
                      icon={<Icons.close></Icons.close>}
                      disabled={
                        formReceiptDto.getFieldValue("id") == null ||
                        (typeForm == LOAI_FORM.DA_TAO &&
                          statusPhieu != TT_PHIEU_VTYT.NHAP &&
                          statusPhieu != TT_PHIEU_VTYT.CHO_DUYET)
                      }
                      loading={loadingBtn}
                    >
                      Hủy
                    </Button>
                  </Popconfirm>

                  <Button
                    type="primary"
                    icon={<Icons.save></Icons.save>}
                    onClick={save}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_VTYT.NHAP &&
                      statusPhieu != TT_PHIEU_VTYT.CHO_DUYET
                      // &&
                      // !(
                      //   statusPhieu == TT_PHIEU_VTYT.HOAN_THANH &&
                      //   typePhieu == LOAI_PHIEU_VTYT.NHAP
                      // )
                    }
                    loading={loadingBtn}
                  >
                    Lưu lại
                  </Button>
                  {typePhieu == LOAI_PHIEU_VTYT.DU_TRU && (
                    <Button
                      className="btn-sub"
                      icon={<Icons.upload></Icons.upload>}
                      onClick={send}
                      disabled={
                        formReceiptDto.getFieldValue("id") == null ||
                        (typeForm == LOAI_FORM.DA_TAO &&
                          statusPhieu != TT_PHIEU_VTYT.NHAP)
                      }
                      loading={loadingBtn}
                    >
                      Gửi phiếu
                    </Button>
                  )}
                  <Button
                    className="btn-sub"
                    onClick={complete}
                    disabled={
                      formReceiptDto.getFieldValue("id") == null ||
                      (typeForm == LOAI_FORM.DA_TAO &&
                        (statusPhieu == TT_PHIEU_VTYT.TU_CHOI ||
                          statusPhieu == TT_PHIEU_VTYT.HUY ||
                          statusPhieu == TT_PHIEU_VTYT.HOAN_THANH))
                    }
                    loading={loadingBtn}
                  >
                    Hoàn thành
                  </Button>
                </Space>
              </Row>
            </Form>
          </div>
        </div>
        <div className="container">
          <Row justify={"space-between"}>
            <Typography.Text strong>Bảng vật tư đưa vào phiếu</Typography.Text>
            {(typeForm == LOAI_FORM.TAO_MOI ||
              typeForm == LOAI_FORM.TAO_MOI_PT) && (
              <Button
                type="primary"
                onClick={() => {
                  boVTRef?.current.openModal();
                }}
              >
                Chọn bộ vật tư
              </Button>
            )}
          </Row>

          <Divider
            type="horizontal"
            style={{margin: 0, marginBottom: 8, marginTop: 4}}
          />
          <div className="container-main">
            <Form form={formTable}>
              <TableInputAdd
                scroll={{x: 1800}}
                setData={setData}
                pagination={false}
                data={[...data]}
                column={columns}
                form={formTable}
                name="listVTYTReceiptDetailDto"
                disabled={
                  statusPhieu == TT_PHIEU_VTYT.HOAN_THANH ||
                  detailRecord?.receiptDto?.isFromPhieuXuat
                }
                setTongTien={setTongTien}
              ></TableInputAdd>
            </Form>
          </div>
        </div>
        <ModalCustom ref={modalRef} width={400} title={`Lý cho từ chối`}>
          <ModalDeny handleDeny={handleDeny}></ModalDeny>
        </ModalCustom>
        <ModalCustom ref={modalRef} width={400} title={`Lý cho từ chối`}>
          <ModalDeny handleDeny={handleDeny}></ModalDeny>
        </ModalCustom>
        <ModalCustom
          wrapClassName="modal-print-form"
          ref={receiptRef}
          width={1100}
          centered
        >
          <ReceiptModal />
        </ModalCustom>
        <ModalCustom
          ref={boVTRef}
          title="Chọn bộ vật tư"
          onOpenModal={() => {
            childRef?.current?.resetFields();
          }}
        >
          <BoVTModal
            khoXuatId={khoXuatId}
            setDataTable={setDataTable}
            ref={childRef}
          ></BoVTModal>
        </ModalCustom>
      </div>
    </Spin>
  );
};

export default Detail;
